import React from 'react';
import PropTypes from 'prop-types';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from 'Components/UI/Button';
import { Schedule } from '@material-ui/icons';
import { FDTooltip } from '@facet-wealth/design';

function ScheduleButton({
  onClickSend,
  sendButtonLabel,
  onClickSchedule,
}) {
  return (
    <ButtonGroup variant="contained">
      <Button
        color="secondary"
        disableElevation
        onClick={onClickSend}
        variant="contained"
      >
        {sendButtonLabel}
      </Button>
      <FDTooltip title={'Schedule agenda'} placement="top">
        <Button
          color="secondary"
          disableElevation
          onClick={onClickSchedule}
          variant="contained"
          test="schedule-agenda-button"
        >
          <Schedule fontSize="small" />
        </Button>
      </FDTooltip>
    </ButtonGroup>
  );
}

ScheduleButton.defaultProps = {
};

ScheduleButton.propTypes = {
  onClickSend: PropTypes.func.isRequired,
  sendButtonLabel: PropTypes.string.isRequired,
  onClickSchedule: PropTypes.func.isRequired,
};

ScheduleButton.defaultProps = {
};

export default ScheduleButton;
